import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class SessionService {
  // Observable navItem source
  private _updateDashboardSource = new BehaviorSubject<number>(0);
  private _updateForumsData = new BehaviorSubject<number>(0);
  private _updateActivityState = new BehaviorSubject<number>(0);
  private _updateActivityForumsDisplayState = new BehaviorSubject<number>(0);
  private _updateActivityNotes = new BehaviorSubject<number>(0);
  private _showActivityNotes = new BehaviorSubject<number>(0);
  private _updateAddedToNotesFlag = new BehaviorSubject<number>(0);
  private _closeActivitySidebar = new BehaviorSubject<number>(0);
  private _closeForumsSidebar = new BehaviorSubject<number>(0);
  private _getUserInfo = new BehaviorSubject<any>("");
  private _updateuserInfo = new BehaviorSubject<number>(0);
  private _gettingStartedSections = new BehaviorSubject<any>(""); //added for getting started
  private _getQuizType = new BehaviorSubject<any>("");
  private _getAccessedForums = new BehaviorSubject<any>("");
  private _getSectionName = new BehaviorSubject<any>("");
  private _gettingPurchaseModalData = new BehaviorSubject<any>("");
  private _gettingVerbalLsState = new BehaviorSubject<any>("");
  private _gettingTirialOfferExpiryDate = new BehaviorSubject<any>("");
  private _gettingExpiryDate = new BehaviorSubject<any>("");
  private _getUserPaidStatus = new BehaviorSubject<any>("");
  private _getForumType = new BehaviorSubject<any>("");
  private _getUserRole = new BehaviorSubject<any>("");
  private _getPurchasedExtension = new BehaviorSubject<any>("");
  private _getAlternateUser = new BehaviorSubject<any>("");
  private _getPaymentResponse = new BehaviorSubject<any>("");
  private _getPIKey = new BehaviorSubject<any>("");
  private _getPaceEnabled = new BehaviorSubject<any>("");
  private _courseCompletionTime = new BehaviorSubject<any>("");
  private _levelCollapsed = new BehaviorSubject<any>("collapsed");
  private _webinarComponentState = new BehaviorSubject<any>("collapsed");
  private _pageName = new BehaviorSubject<any>("");
  private _journeyCourseId = new BehaviorSubject<any>("");
  private _dailyStudyHours = new BehaviorSubject<any>("");
  private _userAppcuesSplashScreenFlag = new BehaviorSubject<any>(false);
  private _userAppcuesSplashScreenFlagCustom = new BehaviorSubject<any>(false);
  private _courseName = new BehaviorSubject<string>('');
  private _courseStage = new BehaviorSubject<string>('');
  private _expiredSubscription = new BehaviorSubject<boolean>(false);

  // Observable navItem stream
  updateDashboard$ = this._updateDashboardSource.asObservable();
  updateForumsData$ = this._updateForumsData.asObservable();
  updateActivityState$ = this._updateActivityState.asObservable();
  updateActivityForumsDisplayState$ =
    this._updateActivityForumsDisplayState.asObservable();
  updateActivityNotes$ = this._updateActivityNotes.asObservable();
  showActivityNotes$ = this._showActivityNotes.asObservable();
  updateAddedToNotesFlag$ = this._updateAddedToNotesFlag.asObservable();
  closeActivitySidebar$ = this._closeActivitySidebar.asObservable();
  closeForumsSidebar$ = this._closeForumsSidebar.asObservable();
  getUserInfo$ = this._getUserInfo.asObservable();
  updateuserInfo$ = this._updateuserInfo.asObservable();
  sharedGettingStartedSections = this._gettingStartedSections.asObservable(); //added for getting started
  sharedQuizType = this._getQuizType.asObservable();
  sharedAccessedForumsState$ = this._getAccessedForums.asObservable();
  sharedSectionName$ = this._getSectionName.asObservable();
  sharedGettingPurchaseModalData =
    this._gettingPurchaseModalData.asObservable();
  sharedGettingVerbalLsState = this._gettingVerbalLsState.asObservable();
  sharedTirialOfferExpiryDate =
    this._gettingTirialOfferExpiryDate.asObservable();
  sharedExpiryDate = this._gettingExpiryDate.asObservable();
  sharedUserPaidStatus$ = this._getUserPaidStatus.asObservable();
  sharedForumType = this._getForumType.asObservable();
  sharedUserRole = this._getUserRole.asObservable();
  sharedPurchasedExtension = this._getPurchasedExtension.asObservable();
  sharedAlternateUser = this._getAlternateUser.asObservable();
  sharedPaymentResponse = this._getPaymentResponse.asObservable();
  sharedPIKey = this._getPIKey.asObservable();
  getPaceEnabled$ = this._getPaceEnabled.asObservable();
  courseCompletionTime$ = this._courseCompletionTime.asObservable();
  levelCollapsed = this._levelCollapsed.asObservable();
  getWebinarComponentState = this._webinarComponentState.asObservable();
  getPageName = this._pageName.asObservable();
  journeyCourseId = this._journeyCourseId.asObservable();
  dailyStudyHours$ = this._dailyStudyHours.asObservable();
  userAppcuesSplashScreenFlag = this._userAppcuesSplashScreenFlag.asObservable();
  userAppcuesSplashScreenFlagCustom = this._userAppcuesSplashScreenFlagCustom.asObservable();
  courseName = this._courseName.asObservable();
  courseStage$ = this._courseStage.asObservable();
  getExpiredSubscriptionFlag = this._expiredSubscription.asObservable();



  // service command
  updateDashboard(item) {
    this._updateDashboardSource.next(item);
  }
  updateForumsData(item) {
    this._updateForumsData.next(item);
  }
  updateActivityState(item) {
    this._updateActivityState.next(item);
  }
  updateActivityForumsDisplayState(item) {
    this._updateActivityForumsDisplayState.next(item);
  }
  updateActivityNotes(item) {
    this._updateActivityNotes.next(item);
  }
  showActivityNotes(item) {
    this._showActivityNotes.next(item);
  }
  updateAddedToNotesFlag(item) {
    this._updateAddedToNotesFlag.next(item);
  }
  closeActivitySidebar(item) {
    this._closeActivitySidebar.next(item);
  }
  closeForumsSidebar(item) {
    this._closeForumsSidebar.next(item);
  }
  getUserInfo(item) {
    this._getUserInfo.next(item);
  }
  updateuserInfo(item) {
    this._updateuserInfo.next(item);
  }
  shareGettingStarted(
    item //added for getting started
  ) {
    this._gettingStartedSections.next(item);
  }
  shareQuizType(item) {
    this._getQuizType.next(item);
  }
  shareAccessedForumsState(item) {
    this._getAccessedForums.next(item);
  }
  shareSectionName(item) {
    this._getSectionName.next(item);
  }
  sharepurchaseModalStarted(item) {
    this._gettingPurchaseModalData.next(item);
  }
  shareVerbalLsStateStarted(item) {
    this._gettingVerbalLsState.next(item);
  }

  shareTirialOfferExpiryDateStarted(item) {
    this._gettingTirialOfferExpiryDate.next(item);
  }

  shareExpiryDate(item) {
    this._gettingExpiryDate.next(item);
  }

  shareUserPaidStatus(item) {
    this._getUserPaidStatus.next(item);
  }

  shareForumType(item) {
    this._getForumType.next(item);
  }

  shareUserRole(item) {
    this._getUserRole.next(item);
  }

  sharePurchasedExtendion(item) {
    this._getPurchasedExtension.next(item);
  }
  shareAlternateUser(item) {
    this._getAlternateUser.next(item);
  }

  sharePaymentResponse(item) {
    this._getPaymentResponse.next(item);
  }

  sharePIKey(item) {
    this._getPIKey.next(item);
  }

  updatePaceEnabled(item) {
    this._getPaceEnabled.next(item);
  }

  updateSpentTime(item) {
    this._courseCompletionTime.next(item);
  }

  shareLevelCollapsedStatus(status) {
    this._levelCollapsed.next(status);
  }

  updateWebinarComponentState(state) {
    this._webinarComponentState.next(state);
  }

  updatePageName(pageName) {
    this._pageName.next(pageName);
  }

  updateJourneyCourseId(id){
    this._journeyCourseId.next(id);
  }

  updateDailyStudyHours(hours) {
    this._dailyStudyHours.next(hours);
  }

  updateUserAppcuesSplashScreenFlag(hours) {
    this._userAppcuesSplashScreenFlag.next(hours);
  }

  updateUserAppcuesSplashScreenFlagCustom(hours) {
    this._userAppcuesSplashScreenFlagCustom.next(hours);
  }
  updateCourseName(courseName:string):void{
    this._courseName.next(courseName);
  }

  /**
   * @description update course stage
   * @param stage
   */
  updateCourseStage(stage:string):void{
    this._courseStage.next(stage);
  }

  // share subscritption expired status
  setExpiredSubscriptionFlag(flag:boolean): void {
    this._expiredSubscription.next(flag);
  }
}


